import { initialStatisticalAnalysisHeaderState, StatisticalAnalysisHeaderNavigationItems, StatisticalAnalysisHeaderState, StatisticalAnalysisHeaderValues, StatisticalAnalysisTypeNavigation } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { Vue, Prop, Component, Emit } from 'vue-property-decorator'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
@Component({
    components: {
        Swiper,
        SwiperSlide
    }
})
export default class StatisticalAnalysisHeader extends Vue {
    @Prop() readonly headerParams!: StatisticalAnalysisHeaderValues

    @Emit()
    itemSelected(itemSelected: StatisticalAnalysisHeaderNavigationItems<any>) {
        return itemSelected
    }

    state: StatisticalAnalysisHeaderState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisHeaderState()
        this.state.swiperOptions = {
            ...this.state.swiperOptions,
            ...this.headerParams.optionsSlider
        }
    }

    get isNavigation(): boolean {
        return this.headerParams.navigationType === StatisticalAnalysisTypeNavigation.NAVIGATION
    }

    get isInformation(): boolean {
        return this.headerParams.navigationType === StatisticalAnalysisTypeNavigation.INFO
    }

    get showTotal(): boolean {
        return this.headerParams.header?.showTotal
    }

    get total(): number {
        return this.headerParams.header?.total
    }

    get startDate(): Date {
        return this.headerParams.header?.startDate
    }

    get endDate(): Date {
        return this.headerParams.header?.endDate
    }

    get elementType(): string {
        return this.headerParams.header.elementType
    }

    mounted() {
        this.itemSelected(this.headerParams.navigationItems[0])
    }

    onSelectItem(index: number, item: StatisticalAnalysisHeaderNavigationItems<any>) {
        if (this.state.activeItem !== index) {
            this.state.activeItem = index
            this.itemSelected(item)
        }
    }

    getlabelNavigationItem(label: string): string {
        return label
    }
}
